module.exports = __webpack_public_path__ + "static/img/4a.f123df3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/4a.jpg
// module id = EDK4
// module chunks = 0